import { PrankDefinition, Intensity } from './types';

const BASE_DELAY_MS = 1750;
const DELAY_VARIANCE_MS = 2000;
const INTENSE_MULTIPLIER = 10;

const findScrollableContainer = (): Element | null => {
  const candidates = document.querySelectorAll<HTMLElement>('div, main, section');
  for (const el of Array.from(candidates)) {
    const style = window.getComputedStyle(el);
    const overflowY = style.overflowY;
    if (
      (overflowY === 'auto' || overflowY === 'scroll') &&
      el.scrollHeight > el.clientHeight + 50
    ) {
      return el;
    }
  }
  return null;
};

const phantomScrollPrank: PrankDefinition = {
  namedCode: 'scroll',
  hexCode: 'b3d2',
  create: (intensity) => {
    const speed = intensity === Intensity.INTENSE ? INTENSE_MULTIPLIER : 1;

    const tick = () => {
      const container = findScrollableContainer();
      if (container) {
        container.scrollTop += 1;
      }
      const nextDelay = (Math.floor(Math.random() * DELAY_VARIANCE_MS) + BASE_DELAY_MS) / speed;
      timeoutId = window.setTimeout(tick, nextDelay);
    };

    let timeoutId = window.setTimeout(tick, 2000);

    return () => window.clearTimeout(timeoutId);
  },
};

export default phantomScrollPrank;
